module.exports = __webpack_public_path__ + "custom-config/img/trading_qrcode.30d2ca7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/tv/assets/img/trading_qrcode.png
// module id = FD4Q
// module chunks = 2 3 4 6 7 8 9